export default theme => ({
  container: {
    backgroundColor: theme.palette.grey.main,
    color: theme.palette.grey.contrastText,
    paddingTop: theme.spacing(8),
    paddingBottom: theme.spacing(8),
  },
  title: {
    textTransform: 'uppercase',
    fontWeight: 700,
  },
  logo: {
    cursor: 'pointer',
    width: 60,
    [theme.breakpoints.up('sm')]: {
      width: 80,
    },
    [theme.breakpoints.up('md')]: {
      width: 90,
    },
    [theme.breakpoints.up('lg')]: {
      width: 115,
    },
  },
  p1: {
    paddingRight: theme.spacing(12),
    [theme.breakpoints.down('md')]: {
      paddingRight: theme.spacing(8),
    },
    [theme.breakpoints.down('sm')]: {
      paddingRight: 0,
    },
  },
});
